import { render } from "./ClientUserSelect.vue?vue&type=template&id=0742ef68"
import script from "./ClientUserSelect.vue?vue&type=script&lang=ts"
export * from "./ClientUserSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script